import debug from 'debug';
import alertSolidSvg from 'Minetilbud/Shared/Icons/alert_solid.svg';

const log = debug('ValidateForm:Message');

class Message {
	constructor() {
		this.isEnabled = true;
	}

	/**
	 * @param {boolean} value
	 */
	 enableMessages(value) {
		this.isEnabled = value;
	}

	/**
	 * @param {element} field
	 * @param {Array} messages
	 */
	showErrorMessage(field, messages) {
		if (this.isEnabled) {
			this.toggleMessages(field, messages);
		}

		field.classList.remove('field-messages__valid');
		field.classList.add('field-messages__error');

		if (field.type === 'checkbox') {
			field.parentElement.classList.remove('field-messages__valid');
			field.parentElement.classList.add('field-messages__error');
		}
	}

	/**
	 * @param {element} field
	 */
	showValidMessage(field) {
		if (this.isEnabled) {
			this.toggleMessages(field);
		}

		field.classList.remove('field-messages__error');
		field.classList.add('field-messages__valid');

		if (field.type === 'checkbox') {
			field.parentElement.classList.remove('field-messages__error');
			field.parentElement.classList.add('field-messages__valid');
		}
	}

	/**
	 * @param {element} field
	 * @param {Array} messages
	 */
	 toggleMessages(field, messages) {
		let fieldContainer = field.parentElement;
		if (field.type === 'checkbox') {
			fieldContainer = field.parentElement.parentElement;
		}

		const errorMessage = fieldContainer.querySelector('.field-messages__list');
		if (errorMessage !== null) {
			errorMessage.remove();
		}

		if (typeof messages !== 'undefined') {
			const listNode = document.createElement('ul');
			listNode.className = 'field-messages__list';

			for (var key in messages) {
				if (messages.hasOwnProperty(key)) {
					const listItemNode = document.createElement('li');
					const errorText = document.createTextNode(messages[key]);
					
					listItemNode.className = 'field-messages__list-item';

					listItemNode.appendChild(errorText);
					listItemNode.insertAdjacentHTML('afterbegin', alertSolidSvg);
					listNode.appendChild(listItemNode);
				}
			}

			fieldContainer.append(listNode);
		}
	}
}

export default Message;
